import React from "react";
import Button from "./base/Button";
import { isContributing as getIsContributing } from "../hooks/query/useAccount";
import useOpenAccount, { PATH_SUBSCRIBE } from "../hooks/useOpenAccount";
import uiPrefix from "../utils/UiPrefixUtils";

const SubscribeButton = ({ style, children = "Subscribe" }) => {
  const [openSubscribe] = useOpenAccount({ path: PATH_SUBSCRIBE });
  const isContributing = getIsContributing();
  return isContributing ? null : (
    <Button
      look="primary"
      data-e2e={uiPrefix("subscribe-btn")}
      className={uiPrefix("subscribe-btn")}
      style={style}
      onClick={openSubscribe}
    >
      {children}
    </Button>
  );
};

export default SubscribeButton;
